module.exports = __webpack_public_path__ + "static/media/trumpet-right.668523f1.svg";